import apiClient from '../lib/apiClient';

export const createServiceRequestApi = (payload) =>
  apiClient('/service/request', { method: 'POST', body: payload });

export const getServiceRequestsApi = (params = {}) =>
  apiClient('/service/my-requests', { params });

export const approveGuestRequestApi = (requestId) =>
  apiClient(`/service/guest-request-update/${requestId}`, {
    method: 'PUT',
    body: { requestId },
  });
